/* global femcare */

femcare.askExpert.askQuestion = {
    init: function() {
        const toggleButton = document.querySelector('.ask-expert__form-toggle');
        if (toggleButton) {
            this.askExpertForm(toggleButton);
        }
    },

    /**
     * Init ask expert form toggle.
     * @param {HTMLElement} toggleButton - The button element that toggles the form.
     **/
    askExpertForm: function(toggleButton) {
        let formOpen = false;

        const askExpert = toggleButton.closest('.ask-expert');
        const formWrapper = askExpert.querySelector('.ask-expert-form');

        toggleButton.addEventListener('click', function() {
            formOpen = !formOpen;

            toggleButton.setAttribute('aria-expanded', formOpen);
            formWrapper.setAttribute('aria-expanded', formOpen);

            formWrapper.classList.toggle('hidden', !formOpen);

            if (formOpen) {
                formWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }
};
